module.exports = __webpack_public_path__ + "static/media/Stellapps_logo.e7cc385a.png";